import {graphql} from 'gatsby'
import React, {useEffect, useState} from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import {ITopicPath} from '../../../components/atoms/topicPath'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import PopupBanner from '../../../components/molecules/popupBanner'
import useRouteParam from '../../../hooks/useRouteParam'
import ColumnAuthor005 from '../../../components/molecules/columnAuthor005'
import UsefulFunctionLayout014 from '../../../components/molecules/usefulFunctionLayout014'
import ColumnDetailInner0097 from '../../../components/molecules/columnDetailInner0097'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0097 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title:
        '勤怠管理システムは自作できる？メリットやデメリット・注意点について解説',
    },
  ]

  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="勤怠管理システムは自作できる？メリットやデメリット・注意点について解説"
        description="勤怠管理システムはExcelや自作アプリを活用して、制作することが可能です。ただし、法改正に対応していなければ、企業は法的リスクを負うことになります。本記事では勤怠管理システムを自作した場合に必要な項目や、メリット・デメリットについて解説します。"
        ogUrl="https://kintaicloud.jp/column/details/C0097/"
        ogType="article"
        ogTitle="勤怠管理システムは自作できる？メリットやデメリット・注意点について解説"
        ogDescription="勤怠管理システムはExcelや自作アプリを活用して、制作することが可能です。ただし、法改正に対応していなければ、企業は法的リスクを負うことになります。本記事では勤怠管理システムを自作した場合に必要な項目や、メリット・デメリットについて解説します。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0097.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0097 no={no} />
        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}
        {/** オーサ情報 */}
        <ColumnAuthor005 />
        {/** お役立ち機能 */}
        <UsefulFunctionLayout014 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
        {/* <ColumnRelationCards0097 /> */}
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0097

export const pageQuery = graphql`
  query C0097 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
